import React from 'react';
import styled, { css } from 'styled-components';
import LinkOrButton from '../../LinkOrButton';
import { EqualHousing, Facebook, Instagram, Twitter } from '../../svg';
import { cssByBreakpoint, flex, hover, hoverChild } from '../../../styling';
import { COLORS, MARGINS, TYPOGRAPHY } from '../../../themes';
import { Div } from '../../Styled';
import DatoImageLoader from '../../DatoImageLoader';
var Wrapper = /*#__PURE__*/styled(Div).withConfig({
  displayName: "DashboardFooter__Wrapper",
  componentId: "sc-1cdh7pu-0"
})(["", ""], cssByBreakpoint([css(["border-top:1px solid ", ";margin-top:", "px;padding-top:", "px;"], COLORS.LIGHT_GREY, MARGINS.XXL, MARGINS.LG), [], css(["", ";"], flex('space-between', 'flex-start'))]));
var FooterLinks = /*#__PURE__*/styled(Div).withConfig({
  displayName: "DashboardFooter__FooterLinks",
  componentId: "sc-1cdh7pu-1"
})(["", ""], cssByBreakpoint([css(["", ";margin-bottom:", "px;", ";"], TYPOGRAPHY.S, MARGINS.XXL, flex('center', 'center', 'row', 'wrap')), css(["justify-content:flex-start;"])]));
var FooterLink = /*#__PURE__*/styled(LinkOrButton).withConfig({
  displayName: "DashboardFooter__FooterLink",
  componentId: "sc-1cdh7pu-2"
})(["", ";text-decoration:none;"], hover('color', COLORS.NEUTRAL_500, COLORS.PRIMARY_3));
var FooterCompanyInfo = /*#__PURE__*/styled(Div).withConfig({
  displayName: "DashboardFooter__FooterCompanyInfo",
  componentId: "sc-1cdh7pu-3"
})(["p,a{", " color:", ";text-decoration:none;}"], TYPOGRAPHY.S, COLORS.NEUTRAL_500);
var FooterSocial = /*#__PURE__*/styled(Div).withConfig({
  displayName: "DashboardFooter__FooterSocial",
  componentId: "sc-1cdh7pu-4"
})(["", ""], cssByBreakpoint([css(["margin-top:", "px;", ""], MARGINS.XXL, flex('center')), [], css(["&:first-of-type{margin-top:0;}justify-content:flex-end;"])]));
var AppStoreLink = /*#__PURE__*/styled(LinkOrButton).withConfig({
  displayName: "DashboardFooter__AppStoreLink",
  componentId: "sc-1cdh7pu-5"
})(["display:inline-flex;&.social{width:30px;", ";", ";}&:not(:first-of-type){margin-left:", "px;}&:focus{border-radius:2px;box-shadow:0 0 0 4px ", ";outline:none;}"], flex(), hoverChild('path', 'fill', '#6F768F', COLORS.PRIMARY_3), MARGINS.SM, COLORS.FOCUS);
var SmallDivider = /*#__PURE__*/styled.div.withConfig({
  displayName: "DashboardFooter__SmallDivider",
  componentId: "sc-1cdh7pu-6"
})(["margin:0 ", "px;border-left:1px solid ", ";height:12px;"], MARGINS.SM, COLORS.NEUTRAL_500);

var _ref2 = /*#__PURE__*/React.createElement(FooterLinks, null, /*#__PURE__*/React.createElement(FooterLink, {
  sameTab: true,
  href: "/contact"
}, "Support"), /*#__PURE__*/React.createElement(SmallDivider, null), /*#__PURE__*/React.createElement(FooterLink, {
  sameTab: true,
  href: "/blog"
}, "Blog"), /*#__PURE__*/React.createElement(SmallDivider, null), /*#__PURE__*/React.createElement(FooterLink, {
  sameTab: true,
  href: "/terms"
}, "Terms of Service"), /*#__PURE__*/React.createElement(SmallDivider, null), /*#__PURE__*/React.createElement(FooterLink, {
  sameTab: true,
  href: "/privacy"
}, "Privacy Policy"), /*#__PURE__*/React.createElement(SmallDivider, null), /*#__PURE__*/React.createElement(FooterLink, {
  sameTab: true,
  href: "/licenses"
}, "Licenses"));

var _ref3 = /*#__PURE__*/React.createElement("p", null, "\xA9 2020 Figure Lending LLC dba Figure");

var _ref4 = /*#__PURE__*/React.createElement(LinkOrButton, {
  href: "http://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/1717824",
  sameTab: true
}, "NMLS #1717824 - NMLSCONSUMERACCESS.ORG");

var _ref5 = /*#__PURE__*/React.createElement(FooterSocial, null, /*#__PURE__*/React.createElement(AppStoreLink, {
  className: "social",
  href: "https://www.facebook.com/figure"
}, /*#__PURE__*/React.createElement(Facebook, null)), /*#__PURE__*/React.createElement(AppStoreLink, {
  className: "social",
  href: "https://twitter.com/figure"
}, /*#__PURE__*/React.createElement(Twitter, null)), /*#__PURE__*/React.createElement(AppStoreLink, {
  className: "social",
  href: "https://www.instagram.com/FigureTechnologies/"
}, /*#__PURE__*/React.createElement(Instagram, null)));

var Footer = function Footer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("footer", null, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement("div", null, _ref2, /*#__PURE__*/React.createElement(FooterCompanyInfo, null, _ref3, _ref4, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(EqualHousing, {
    $css: css(["margin-right:4px;"])
  }), "Equal Housing Opportunity"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FooterSocial, null, /*#__PURE__*/React.createElement(AppStoreLink, {
    className: "store",
    href: "https://apps.apple.com/us/app/figure/id1387186310?ls=1"
  }, /*#__PURE__*/React.createElement(DatoImageLoader, {
    $css: css(["width:8.7rem;"]),
    aspectRatio: 87 / 29,
    alt: "Apple Store",
    src: "https://www.datocms-assets.com/33246/1623435276-apple-store.svg"
  })), /*#__PURE__*/React.createElement(AppStoreLink, {
    className: "store",
    href: "https://play.google.com/store/apps/details?id=com.figure.mobile"
  }, /*#__PURE__*/React.createElement(DatoImageLoader, {
    $css: css(["width:9.6rem;"]),
    aspectRatio: 96 / 29,
    alt: "Play Store",
    src: "https://www.datocms-assets.com/33246/1623435279-play-store.svg"
  }))), _ref5)), children);
};

export default Footer;